/**
 * Группировка полей объекта. Модуль для работы с API.
 * @module definitionGroups
 */

/**
 * Создание группы полей для страницы объекта
 * @param {Object} item - данные группы
 * @returns {Promise} - созданная группа
 * @throws {Error} - ошибка при создании данных
 */
export const createGroup = async (item) => {
  try {
    const response = await fetch("/api/definitionelementformgroup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при создании данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.group;
  } catch (err) {
    throw err;
  }
};

/**
 * Обновление группы полей для страницы объекта
 * @param {Object} item - данные группы
 * @returns {Promise} - обновленная группа
 * @throws {Error} - ошибка при обновлении данных
 */
export const updateGroup = async (item) => {
  try {
    const response = await fetch("/api/definitionelementformgroup", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при обновлении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.group;
  } catch (err) {
    throw err;
  }
};

/**
 * Удаление группы полей
 * @param {Object} item - данные группы
 * @returns {Promise} - удаленная группа
 * @throws {Error} - ошибка при удалении данных
 */
export const deleteGroup = async (item) => {
  try {
    const response = await fetch("/api/definitionelementformgroup", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при удалении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.group;
  } catch (err) {
    throw err;
  }
};

/**
 * Добавление полей в группу
 * @param {Object} item - группа с новыми полями
 * @returns {Promise} - обновленная группа
 * @throws {Error} - ошибка при добавлении данных
 */
export const addFieldsFromGroup = async (item) => {
  try {
    const response = await fetch("/api/definitionsfields/addtogroup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error("Ошибка при добавлении данных. Попробуйте снова.");
    }

    return data.group;
  } catch (err) {
    throw err;
  }
};
